import { useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';
import _ from 'lodash';

import { firstGenerateMenu } from '../../actions/menus';
import ProgressBar from '../ProgressBar/ProgressBar';
import styles from './Steps.module.css';

const Step11 = (props) => {
  const { 
    onSave, 
    stepsData,
    firstGenerateMenu,
  } = props;

  const [days, setDays] = useState(stepsData.days || undefined);
  const location = useLocation();

  const onSaveHandler = () => {
    onSave({ days }, () => {
      if (location.pathname !== '/edit') {
        // console.log('===firstGenerateMenu');
        firstGenerateMenu();
      }
    });
  };

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar onSave={onSave} />
      <div className={styles.daysContent}>
        <div className={styles.stepHeader}>
          How many days do you need a meal plan for?
        </div>
        <div className={styles.daysSelect}>
          {_.times(7).map((_, index) => {
            const day = 7 - index;
            return (
              <div 
                key={index} 
                className={cn(styles.dayButton, { [styles.active]: days == day})}
                onClick={() => setDays(day)}
              >
                {day}
              </div>
            );
          })}
        </div>
        <div className={styles.bottomButton}>
          <button
            className="green-button"
            onClick={onSaveHandler}
            disabled={setDays === undefined}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  firstGenerateMenu,
};

export default connect(null, mapDispatchToProps)(Step11);